import { useQuery } from "@apollo/client";

import { useReviewVisitPanelStatus } from "../../hooks/useReviewVisitPanelStatus";
import { ProjectReviewVisitV2OverviewRoute_GetDataDocument } from "./queries.generated";

export function useProjectReviewVisitV2OverviewRoute_GetData(visitId: string) {
    const { data, loading, error, previousData } = useQuery(ProjectReviewVisitV2OverviewRoute_GetDataDocument, {
        variables: { visitId },
        fetchPolicy: "cache-and-network",
        nextFetchPolicy: "cache-first",
        errorPolicy: "all",
    });

    const result = loading ? previousData : data;
    const visit = result?.plannerV2VisitGetById;

    const { panelStatus, isEverythingReady } = useReviewVisitPanelStatus(result);

    return {
        visit,
        panelStatus,
        isEverythingReady,
        loading,
        error,
    };
}
